// CSV utilities — parser รองรับ field มี comma ในเครื่องหมายคำพูด + map หัวคอลัมน์ (ไทย/อังกฤษ)
export function parseCsv(text) {
  const rows = [];
  let row = [], cell = '', q = false;
  for (let i = 0; i < text.length; i++) {
    const c = text[i];
    if (q) {
      if (c === '"' && text[i + 1] === '"') { cell += '"'; i++; }
      else if (c === '"') q = false;
      else cell += c;
    } else if (c === '"') q = true;
    else if (c === ',') { row.push(cell); cell = ''; }
    else if (c === '\n') { row.push(cell); rows.push(row); row = []; cell = ''; }
    else if (c === '\r') { /* skip */ }
    else cell += c;
  }
  if (cell.length || row.length) { row.push(cell); rows.push(row); }
  return rows.filter(r => r.some(x => x.trim()));
}

// แถวแรก = หัวคอลัมน์ → map เป็นชื่อ field ตาม colmap; คืน [{field: value}]
export function csvToRecords(text, colmap) {
  const rows = parseCsv(text);
  if (rows.length < 2) return [];
  const headers = rows[0].map(h => {
    const raw = h.trim();
    return colmap[raw.toLowerCase().replace(/\s+/g, '')] ?? colmap[raw] ?? null;
  });
  return rows.slice(1).map(r => {
    const rec = {};
    headers.forEach((f, i) => { if (f && (r[i] ?? '').trim()) rec[f] = r[i].trim(); });
    return rec;
  });
}
